import React from 'react';
import PropTypes from 'prop-types';
import { MdArrowDropDown } from 'react-icons/md';

import styles from '../input-select.module.css';

const InputSelectMobile = ({ options, value, captureSelectData }) => {
  const onSelect = selectValue => {
    captureSelectData(selectValue.target.value);
  };

  const renderSelectOptions = () => {
    return options.map((option, index) => {
      return (
        <option key={index} value={option.value}>
          {option.value}
        </option>
      );
    });
  };
  return (
    <React.Fragment>
      <select name="select" onChange={onSelect} value={value}>
        <option defaultValue={value} disabled>
          Select Category
        </option>
        {renderSelectOptions()}
      </select>
      <span className={styles.icon}>
        <MdArrowDropDown />
      </span>
    </React.Fragment>
  );
};

InputSelectMobile.propTypes = {
  options: PropTypes.array,
  value: PropTypes.string,
  captureSelectData: PropTypes.func,
};

export default InputSelectMobile;



// WEBPACK FOOTER //
// ./src/components/form/inputs/input-select/input-select-mobile/index.js